import React from 'react';
import { Text, View } from 'react-native';

export default function FCMComponent() {
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Text>Sample React ntive notification</Text>
    </View>
  );
}
